// ─────────────────────────────────────────────────────────────────────────────
// Falas do fim de batalha/missão (balão ao lado do personagem no ResultCard).
//  - victory: o SEU personagem comemorando.
//  - defeat:  o monstro que te venceu provocando.
// Humor, desafio e sarcasmo. pt e en têm o mesmo tamanho e a mesma ordem.
// ─────────────────────────────────────────────────────────────────────────────

export type QuoteKind = 'victory' | 'defeat';
export type QuoteLang = 'pt' | 'en';

export const RESULT_QUOTES: Record<QuoteKind, Record<QuoteLang, string[]>> = {
  victory: {
    pt: [
      'Parabéns, Comandante! Ótimo trabalho hoje!',
      'Mais um mapa limpo. Alguém anota isso na minha lenda?',
      'Eles vieram em bando. Saíram em pedaços.',
      'Nem suei. Tá, suei um pouquinho.',
      'Vitória! Agora vamos ver o que caiu desses coitados.',
      'Se isso era o melhor deles, estou decepcionado.',
      'Mais um dia, mais uma vitória. Rotina de herói.',
      'Os monstros vão contar histórias sobre mim. Histórias de terror.',
      'Essa foi por pouco… para eles!',
      'Alguém chama o bardo, isso merece uma canção!',
      'Ganhei! E nem precisei do plano B.',
      'Quem é o próximo? Estou só aquecendo.',
      'Arrumei a bagunça. De nada, reino.',
      'Minha espada agradece o exercício.',
      'Eles tinham números. Eu tinha estilo.',
      'Missão dada é missão cumprida, Comandante!',
      'Vitória com gostinho de mel. E de poeira.',
      'Acho que vou precisar de uma mochila maior.',
      'Mais fácil que roubar doce de goblin.',
      'Contem para todos: eu venci e fiquei bonito fazendo isso.',
      'Se cair mais um, eu nem percebo.',
      'O campo é nosso! Bandeira para cima!',
      'Tática perfeita. Bom, quase perfeita.',
      'Eu disse que dava. Ninguém acreditou. Deu.',
      'Hoje o lanche é por conta dos derrotados.',
      'Isso é o que acontece quando se mexe comigo.',
      'Mais um capítulo glorioso para o diário.',
      'Respira, Comandante. A gente ganhou!',
      'Os pássaros cantam a minha vitória. Ou só estão com fome.',
      'Ninguém fica no meu caminho por muito tempo.',
      'Venci com uma mão. A outra estava segurando a coragem.',
      'Que batalha! Preciso de um banho e de um troféu.',
      'Deixa eu adivinhar: eles não esperavam isso.',
      'Experiência ganha, ego aumentado.',
      'Mapa conquistado. Próxima aventura, por favor!',
      'Se fosse fácil, chamariam outro. Chamaram eu.',
      'Que nem passeio no parque. Com monstros. E gritos.',
      'O inimigo caiu. Minha moral subiu.',
      'Acabou! Alguém viu a minha poção?',
      'Vitória registrada. Ranking, aí vou eu!',
      'Batalha vencida, lenda alimentada.',
      'Eles fugiram? Não, eles perderam mesmo.',
      'Fiz parecer fácil. É porque é.',
      'Um brinde à coragem — e à boa mira!',
      'Comandante, mais um troféu para a estante!',
      'Eles rugiram alto. Eu bati mais forte.',
      'Para a próxima, tragam reforços. Vão precisar.',
      'Glória, ouro e um pouco de lama na bota.',
      'O reino dorme tranquilo hoje. Graças a mim.',
      'Vencemos! Vamos conferir o que ganhamos?',
    ],
    en: [
      'Congratulations, Commander! Great work today!',
      'Another map cleared. Someone write this into my legend?',
      'They came as a pack. They left in pieces.',
      'Didn’t even break a sweat. Okay, maybe a little.',
      'Victory! Now let’s see what those poor things dropped.',
      'If that was their best, I’m disappointed.',
      'Another day, another victory. Hero routine.',
      'Monsters will tell stories about me. Horror stories.',
      'That was close… for them!',
      'Someone call the bard, this deserves a song!',
      'I won! And didn’t even need plan B.',
      'Who’s next? I’m just warming up.',
      'Cleaned up the mess. You’re welcome, kingdom.',
      'My sword thanks you for the exercise.',
      'They had numbers. I had style.',
      'Mission given is mission done, Commander!',
      'Victory tastes like honey. And dust.',
      'I think I’m going to need a bigger backpack.',
      'Easier than stealing candy from a goblin.',
      'Tell everyone: I won and looked good doing it.',
      'If one more falls, I won’t even notice.',
      'The field is ours! Raise the banner!',
      'Perfect tactics. Well, almost perfect.',
      'I said I could do it. Nobody believed me. I did it.',
      'Today the losers are buying lunch.',
      'That’s what happens when you mess with me.',
      'Another glorious chapter for the journal.',
      'Breathe, Commander. We won!',
      'The birds sing of my victory. Or they’re just hungry.',
      'Nobody stays in my way for long.',
      'Won it one-handed. The other was holding my courage.',
      'What a battle! I need a bath and a trophy.',
      'Let me guess: they didn’t see that coming.',
      'Experience gained, ego increased.',
      'Map conquered. Next adventure, please!',
      'If it were easy they’d call someone else. They called me.',
      'Like a walk in the park. With monsters. And screaming.',
      'The enemy fell. My morale rose.',
      'It’s over! Has anyone seen my potion?',
      'Victory logged. Ranking, here I come!',
      'Battle won, legend fed.',
      'Did they run away? No, they really lost.',
      'I made it look easy. Because it is.',
      'A toast to courage — and good aim!',
      'Commander, another trophy for the shelf!',
      'They roared loud. I hit harder.',
      'Next time, bring backup. You’ll need it.',
      'Glory, gold and a little mud on my boots.',
      'The kingdom sleeps soundly tonight. Thanks to me.',
      'We won! Shall we check what we earned?',
    ],
  },
  defeat: {
    pt: [
      'Você não foi páreo para mim.',
      'Eu imaginava que você era capaz de uma vitória, mas me enganei.',
      'Volte quando tiver crescido um pouco.',
      'Era isso? Eu nem tinha começado.',
      'Que fofo, você achou que ia ganhar.',
      'Diga ao seu Comandante que mandou o herói errado.',
      'Vou guardar sua espada como lembrancinha.',
      'Treine mais. Muito mais. Tipo, muito mesmo.',
      'Seus gritos foram a melhor parte.',
      'Até meu bichinho de estimação teria durado mais.',
      'Que pena. Eu estava começando a me divertir.',
      'Isso foi uma batalha ou um tutorial?',
      'Pode ir. Eu deixo você tentar de novo. Hehehe.',
      'Corajoso, sim. Esperto, nem tanto.',
      'Achei que heróis fossem mais resistentes.',
      'Eu vou contar essa história no jantar.',
      'Volte sempre. Eu adoro vencer.',
      'Seu equipamento é bonito. Pena que não ajudou.',
      'Da próxima vez, traga amigos. Muitos amigos.',
      'Você lutou como um goblin com sono.',
      'Nem precisei usar meu golpe especial.',
      'Ah, é você de novo? Que surpresa… não.',
      'Eu sou o pesadelo que você não esperava.',
      'Descanse. Você vai precisar.',
      'Herói? Eu vi foi um figurante.',
      'Errou o golpe, errou o plano, errou o dia.',
      'Essa poção aí era de enfeite?',
      'Corre, que da próxima eu não serei tão gentil.',
      'Eu sinto o cheiro do medo daqui.',
      'Parabéns! Você chegou… em segundo lugar.',
      'Que tal tentar uma profissão mais segura? Tipo pescador.',
      'Meu ranking agradece os pontos.',
      'Você quase me assustou. Quase.',
      'Seus ancestrais estão envergonhados.',
      'Eu vou dormir tranquilo hoje. E você?',
      'Ninguém passa por mim. Muito menos você.',
      'Foi rápido. Rápido demais.',
      'Eu tinha apostado em mim. Ganhei.',
      'Volte quando sua coragem combinar com seu tamanho.',
      'Que decepção. Esperava mais drama.',
      'Seu escudo pediu demissão no meio da luta.',
      'Isso que é derrota com estilo… do meu lado.',
      'O mapa é meu. A vitória também.',
      'Você perdeu, mas pelo menos foi engraçado.',
      'Aposto que você vai voltar. E vai perder de novo.',
      'Até a sua sombra fugiu antes de você.',
      'Que tal mais um nível antes da revanche?',
      'Eu sou o chefe desta área. Respeite.',
      'Hoje não, herói. Hoje não.',
      'Quando quiser outra surra, estarei aqui.',
    ],
    en: [
      'You were no match for me.',
      'I thought you were capable of victory, but I was wrong.',
      'Come back when you’ve grown up a little.',
      'That was it? I hadn’t even started.',
      'How cute, you thought you would win.',
      'Tell your Commander they sent the wrong hero.',
      'I’ll keep your sword as a souvenir.',
      'Train more. A lot more. Like, a whole lot.',
      'Your screams were the best part.',
      'Even my pet would have lasted longer.',
      'What a shame. I was just starting to have fun.',
      'Was that a battle or a tutorial?',
      'Go on. I’ll let you try again. Hehehe.',
      'Brave, yes. Smart, not so much.',
      'I thought heroes were tougher.',
      'I’ll tell this story at dinner.',
      'Come back anytime. I love winning.',
      'Nice gear. Too bad it didn’t help.',
      'Next time, bring friends. Lots of friends.',
      'You fought like a sleepy goblin.',
      'I didn’t even need my special move.',
      'Oh, it’s you again? What a surprise… not.',
      'I’m the nightmare you didn’t expect.',
      'Rest. You’ll need it.',
      'A hero? I saw an extra.',
      'Missed the hit, missed the plan, missed the day.',
      'Was that potion just decoration?',
      'Run, next time I won’t be so gentle.',
      'I can smell the fear from here.',
      'Congratulations! You came… second.',
      'How about a safer career? Like fishing.',
      'My ranking thanks you for the points.',
      'You almost scared me. Almost.',
      'Your ancestors are ashamed.',
      'I’ll sleep soundly tonight. Will you?',
      'Nobody gets past me. Least of all you.',
      'That was quick. Too quick.',
      'I bet on myself. I won.',
      'Come back when your courage matches your size.',
      'What a letdown. I expected more drama.',
      'Your shield quit in the middle of the fight.',
      'Now that’s a stylish defeat… on my side.',
      'The map is mine. So is the victory.',
      'You lost, but at least it was funny.',
      'I bet you’ll come back. And lose again.',
      'Even your shadow ran away before you did.',
      'How about one more level before the rematch?',
      'I’m the boss of this area. Show some respect.',
      'Not today, hero. Not today.',
      'Whenever you want another beating, I’ll be here.',
    ],
  },
};

const LAST_KEY = (kind: QuoteKind) => `result_quote_last_${kind}`;
/** Última fala em memória — vale mesmo sem localStorage (modo privado, testes). */
const lastShown: Record<QuoteKind, number> = { victory: -1, defeat: -1 };

/**
 * Sorteia uma fala sem repetir a última mostrada (guardada no localStorage).
 * `rand` é injetável para teste.
 */
export function pickQuote(kind: QuoteKind, lang: string, rand: () => number = Math.random): string {
  const list = RESULT_QUOTES[kind][lang === 'en' ? 'en' : 'pt'];
  let last = lastShown[kind];
  try { last = Number(localStorage.getItem(LAST_KEY(kind)) ?? last); } catch { /* sem storage */ }
  let i = Math.floor(rand() * list.length) % list.length;
  if (i === last && list.length > 1) i = (i + 1) % list.length;
  lastShown[kind] = i;
  try { localStorage.setItem(LAST_KEY(kind), String(i)); } catch { /* sem storage */ }
  return list[i];
}
